import { createSelector } from 'reselect'
import { areArraysEqual } from 'util/arrays'
import { selectCurrentBillingCycle } from './selectCurrentBillingCycle'
import { selectCurrentPricingIds } from './selectCurrentPricingIds'
import { selectFuturePhase } from './selectFuturePhase'
import { selectPricings } from './selectPricings'

const normalizeIds = ids => [...new Set(ids.map(String))].sort()

export const selectIsPendingAnnualSwitch = createSelector(
  selectCurrentBillingCycle,
  selectCurrentPricingIds,
  selectFuturePhase,
  selectPricings,
  (cycle, currentIds, futurePhase, pricings) => {
    if (
      cycle !== 'monthly' ||
      !Number.isFinite(futurePhase?.startDate) ||
      futurePhase.startDate <= 0 ||
      !Array.isArray(futurePhase.items) ||
      futurePhase.items.length === 0 ||
      currentIds.length === 0 ||
      !currentIds.every(
        id =>
          id != null &&
          pricings.some(pricing => String(pricing.id) === String(id))
      )
    ) {
      return false
    }

    const futureIds = []
    const allAnnual = futurePhase.items.every(item => {
      if (!item?.plan) return false
      const matches = pricings.filter(
        pricing => pricing.externalAnnualPriceId === item.plan
      )
      if (
        matches.length !== 1 ||
        matches[0].id == null ||
        pricings.some(pricing => pricing.externalMonthlyPriceId === item.plan)
      ) {
        return false
      }
      futureIds.push(matches[0].id)
      return true
    })

    return (
      allAnnual &&
      areArraysEqual(normalizeIds(currentIds), normalizeIds(futureIds))
    )
  }
)
